import React, { useState, useEffect, useRef } from "react";
import * as Types from "../types/BaseTypes";
import Classification from "../objects/Classification";
import Category from "../objects/Category";
import Refrigerant from "../objects/Fluids";
import AnimatedText from "./common/AnimatedText";
import { useTrail, animated } from "react-spring";

interface Navigation {
  tab: number;
  onClick: Function;
  direction: Function;
  data: {
    core: Types.Core;
    room: Types.Room;
  };
}

export default ({ tab, onClick, direction, data }: Navigation) => {
  const ref = useRef<HTMLDivElement>(null);
  const [navSize, setNavSize] = useState<number[]>([1, 2, 3, 4, 5]);
  const [isMobile, setIsmobile] = useState(false);
  const handleResize = () => {
    const width = ref.current ? ref.current.offsetWidth : 0;
    setIsmobile(width < 815);
    if (width < 815) {
      const offset = 10 + 6;
      setNavSize([
        70 / 2 + offset,
        width / 4 + offset + 15,
        (width / 4) * 2 + offset - offset / 2.5,
        (width / 4) * 3 + offset - offset / 1 - 12,
        (width / 4) * 4 - offset + offset / 1.8 - 20,
      ]);
    } else {
      const offset = 70 + 6;
      setNavSize([
        70 / 2 + offset,
        width / 4 + offset,
        (width / 4) * 2 + offset - offset / 2.5,
        (width / 4) * 3 + offset - offset / 1 + 2,
        (width / 4) * 4 - offset + offset / 1.8 + 5,
      ]);
    }
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [ref.current]);

  useEffect(() => {
    handleResize();
    setNavButton(""); // reset nav button animation by class
    const timeout = setTimeout(() => {
      setNavButton("new"); // start new growth of nav button
    }, 20);
    setHoverTab(tab);

    return () => {
      clearTimeout(timeout);
    };
  }, [tab]);

  const [navButton, setNavButton] = useState("new");

  const [hoverTab, setHoverTab] = useState(tab);
  const trail = useTrail(1, { width: navSize[hoverTab - 1] });

  return (
    <div ref={ref} className={"navigation"}>
      {trail.map(({ width }, index) => (
        <animated.span
          className={navButton}
          key={index}
          style={{ width }}
        ></animated.span>
      ))}
      <ul onMouseLeave={() => setHoverTab(tab)}>
        <li
          onMouseEnter={() => setHoverTab(1)}
          onClick={() => {
            onClick(1);
            direction(1);
          }}
          style={isMobile ? { marginLeft: 10 } : { marginLeft: 70 }}
        >
          <span>
            <b>{isMobile ? "Location" : "Location Classification"}</b>
            <br />
            <AnimatedText
              value={Classification[data.core.classification - 1].id}
              prefix="Class"
            />
          </span>
        </li>
        <li
          onMouseEnter={() => setHoverTab(2)}
          onClick={() => {
            onClick(2);
            direction(2);
          }}
        >
          <span>
            <b className={tab < 2 ? "gray" : ""}>
              {isMobile ? "Category" : "Access Categories"}
            </b>
            <br />
            <AnimatedText
              className={tab < 2 ? "gray" : ""}
              value={Category[data.core.category - 1].id}
            />
          </span>
        </li>
        <li
          onMouseEnter={() => setHoverTab(3)}
          onClick={() => {
            onClick(3);
            direction(3);
          }}
        >
          <span>
            <b className={tab < 3 ? "gray" : ""}>Refrigerant</b>
            <br />
            <AnimatedText
              className={tab < 3 ? "gray" : ""}
              value={Refrigerant[data.core.refrigerant].id}
              isMobile={isMobile}
              prefix="Opteon™"
            />
          </span>
        </li>
        <li
          onMouseEnter={() => setHoverTab(4)}
          onClick={() => {
            onClick(4);
            direction(4);
          }}
        >
          <span>
            <b className={tab < 4 ? "gray" : ""}>
              {isMobile ? "Dimension" : "Room Dimensions"}
            </b>
            <br />
            <AnimatedText
              className={tab < 4 ? "gray" : ""}
              value={
                data.core.application === Types.Application.HumanComfort
                  ? `${data.room.square.toFixed(2)} m²`
                  : `${data.room.cubic.toFixed(2)} m³`
              }
            />
          </span>
        </li>
        <li
          onMouseEnter={() => setHoverTab(5)}
          onClick={() => {
            onClick(5);
            direction(5);
          }}
        >
          <span>
            <b className={tab < 5 ? "gray" : ""}>Result</b>
            <br />
          </span>
        </li>
      </ul>
    </div>
  );
};
